import Drawer from "../../drawer/Drawer";
import ColorSchema from "../../../assets/kits/colors";
import TimePicker from "./TimePicker";
import TimePicker2 from "./TimePicker2";
import SimpleSlider from "./SimpleSlider";
import CustomButton from "../../kits/custom-button/CustomButton";
import React from "react";

/*

    Example:

        const [isOpen, setIsOpen] = useState(true); // state for open and close

        <SearchProductDrawer open={isOpen} setIsOpen={setIsOpen}/> // Componnent


 */

const TimePickerDrawer = ({open, setIsOpen, className}) => {

    return (
        <>
            <Drawer
                isOpen={open} onClose={() => setIsOpen(false)} height={300} className={`d-flex ${className}`}>
                <div className="d-flex flex-column pd-x-16 pd-t-16 search-drawer overflow-hidden">
                    <span className="title-h3-b"
                          style={{color: ColorSchema.foreground_background_he}}>انتخاب ساعت</span>
                </div>

                {/*<TimePicker2/>*/}
                <div className="d-flex justify-content-center">
                    <div>
                        <SimpleSlider
                            title="از ساعت"
                            containerClassName="mr-t-16"
                            setActive={5}
                            onChange={(value) => {
                                console.log("startClock: ", value);
                            }}/>
                    </div>
                    <div style={{marginRight: "70px"}}>
                        <SimpleSlider
                            title="تا ساعت"
                            containerClassName="mr-t-16"
                            setActive={10}
                            onChange={(value) => {
                                console.log("endClock: ", value);
                            }}/>
                    </div>

                    <div className="w-100 pd-16 position-absolute bottom-0 fixed-bottom bg-white">
                        <CustomButton
                            size="large"
                            className="w-100"
                        >
                            تایید
                        </CustomButton>
                    </div>

                </div>


                {/*<TimePicker2/>*/}

            </Drawer>

        </>
    );
};


export default TimePickerDrawer;